import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import InputPassword from "@/components/ui/input/InputPassword.vue";
  import useVuelidate from "@vuelidate/core";
  import { email, required } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
    loginError: {
      type: String,
    },
    joining: {
      type: Boolean,
      default: false,
    },
    transitionName: {
      type: String,
    },
  },
  emits: ["close", "login", "join", "forgotPassword"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const form = reactive({
    password: "",
    email: "",
  });
  const rules = {
    password: { required, $autoDirty: false },
    email: { required, email, $autoDirty: false },
  };
  const modalClasses = computed(() => {
    return `${
      props.joining ? "login-modal" : "login-modal-shorted"
    } height-limited`;
  });

  const v$ = useVuelidate(rules, form, { $stopPropagation: true });

  const isDisabledLogin = computed(
    () =>
      Boolean(!form.password.length) ||
      Boolean(!form.email.length) ||
      v$.value.email.$error
  );

  function close() {
    emits("close");
    resetVuelidateErrors(v$);
    clearForm();
  }
  async function login() {
    v$.value.$touch();
    const isNoErrors = await v$.value.$validate();

    if (!isNoErrors) return;

    const data = {
      email: form.email.toLowerCase(),
      password: form.password,
    };

    emits("login", data);
  }
  function join() {
    emits("join");
  }
  function clearForm() {
    form.email = "";
    form.password = "";
  }
  function onForgotPassword() {
    resetVuelidateErrors(v$);
    clearForm();
    emits("forgotPassword");
  }

const __returned__ = { emits, props, form, rules, modalClasses, v$, isDisabledLogin, close, login, join, clearForm, onForgotPassword, computed, reactive, Modal, InputPassword, get useVuelidate() { return useVuelidate }, get email() { return email }, get required() { return required }, get resetVuelidateErrors() { return resetVuelidateErrors } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})